import type { GPUInstanceType } from "types/InstanceTypes";
import type { ProcessedLaunchableData } from "components/Launchables/utils";
import { cloneDeep } from "lodash";
import { getPrimaryInstanceCloudCredId } from "utils/cloudCreds";

interface CreateLaunchableDeploymentDataOptions {
  launchableData: ProcessedLaunchableData | null;
  instanceType: GPUInstanceType | null;
  storage: string | null;
  selectedLocation?: string | null;
  lifecycleScript: string | null;
}

export const createLaunchableDeploymentData = ({
  launchableData,
  instanceType,
  storage,
  selectedLocation,
  lifecycleScript,
}: CreateLaunchableDeploymentDataOptions) => {
  const deploymentData = launchableData ? cloneDeep(launchableData) : null;

  if (deploymentData && storage) {
    deploymentData.diskStorage = storage;
  }
  if (deploymentData && instanceType) {
    deploymentData.instanceType = instanceType.type;
    deploymentData.cloudCredId =
      getPrimaryInstanceCloudCredId(instanceType) || deploymentData.cloudCredId;
  }
  if (deploymentData && selectedLocation !== undefined) {
    if (deploymentData.location !== selectedLocation) {
      deploymentData.subLocation = null;
    }
    deploymentData.location = selectedLocation;
  }
  if (deploymentData?.containerSelected?.vmBuild?.lifeCycleScriptAttr?.id) {
    deploymentData.containerSelected.vmBuild.lifeCycleScriptAttr.script =
      lifecycleScript || "";
  }

  return deploymentData;
};
